import { MessageCircle, Mail, Phone } from "lucide-react";
import { waLink, WA_NUMBER } from "@/lib/api";
import { LogoImg } from "./Logo";

export const Footer = () => (
  <footer className="bg-mossdeep text-alabaster">
    <div className="max-w-6xl mx-auto px-6 py-16">
      <div className="grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <LogoImg variant="white" className="h-12 w-auto" />
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-alabaster/50">
                Consulenza scientifica antiparassitaria
              </p>
            </div>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-alabaster/60">
            Per. Agr. Dott. Giuseppe Vincenti — Dottore in Scienze Agroalimentari e Perito
            Agrario. Consulenza telefonica specialistica per risolvere infestazioni
            in autonomia, con metodo scientifico e minima spesa.
          </p>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold font-bold mb-5">
            Contatti diretti
          </p>
          <div className="space-y-3 text-sm">
            <a
              href={waLink("Buongiorno Dott. Vincenti, vorrei informazioni sulle consulenze di disinfestazione.")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="flex items-center gap-3 text-alabaster/80 hover:text-gold transition-colors"
            >
              <MessageCircle size={16} className="text-gold" />
              WhatsApp +{WA_NUMBER.slice(0, 2)} {WA_NUMBER.slice(2, 5)} {WA_NUMBER.slice(5)}
            </a>
            <a
              href="tel:+393357217462"
              data-testid="footer-phone-link"
              className="flex items-center gap-3 text-alabaster/80 hover:text-gold transition-colors"
            >
              <Phone size={16} className="text-gold" />
              +39 335 7217462
            </a>
            <a
              href="mailto:infoserviziprofessionali@gmail.com"
              data-testid="footer-email-link"
              className="flex items-center gap-3 text-alabaster/80 hover:text-gold transition-colors"
            >
              <Mail size={16} className="text-gold" />
              infoserviziprofessionali@gmail.com
            </a>
          </div>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold font-bold mb-5">
            Il metodo
          </p>
          <ul className="space-y-2.5 text-sm text-alabaster/60">
            <li>Analisi scientifica del parassita</li>
            <li>Prodotti professionali a costo reale</li>
            <li>Piano d'azione fai-da-te guidato</li>
            <li>Nessun contratto, nessun vincolo</li>
          </ul>
          <div className="mt-6 space-y-2.5 text-sm">
            <a href="/crediti" data-testid="footer-credits-link" className="block text-alabaster/80 hover:text-gold transition-colors">
              Area Voucher — verifica saldo e validità
            </a>
            <a href="/admin" data-testid="footer-admin-link" className="block text-alabaster/40 hover:text-gold transition-colors text-xs">
              Area Riservata
            </a>
          </div>
        </div>
      </div>
      <div className="mt-14 pt-8 border-t border-mosslight/30 flex flex-wrap items-center justify-between gap-4">
        <p className="text-xs text-alabaster/40">
          © {new Date().getFullYear()} GreenLab — Dott. Giuseppe Vincenti. Tutti i diritti riservati.
        </p>
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-alabaster/40">
          Pagamenti sicuri con Stripe
        </p>
      </div>
    </div>
  </footer>
);
